module.exports = __webpack_public_path__ + "static/media/iStock-1081929288.f571307f.jpg";